import { render } from "./Food.vue?vue&type=template&id=32494206"
import script from "./Food.vue?vue&type=script&lang=js"
export * from "./Food.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/AdvancedSearch/Food.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32494206"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32494206', __exports__)) {
    api.reload('32494206', __exports__)
  }
  
  module.hot.accept("./Food.vue?vue&type=template&id=32494206", () => {
    api.rerender('32494206', render)
  })

}


export default __exports__